import { combineReducers } from 'redux'
import * as actionTypes from './actionTypes'
import _isEqual from 'lodash/isEqual'

export const currentDataReducer = (state = {}, action) => {
	switch (action.type) {
		case actionTypes.UPDATE_BOOK_FIELD:
			return {
				...state,
				[action.fieldName]: action.fieldValue,
			}

		case actionTypes.UPDATE_BOOK_FIELDS:
			return {
				...state,
				...action.delta,
			}

		case actionTypes.CLEAR_BOOK_FIELDS:
			return {}

		default:
			return state
	}
}

export const savedDataReducer = (state = {}, action) => {
	switch (action.type) {
		case actionTypes.GET_BOOK_INPUT_DATA_SUCCESS:
		case actionTypes.SUBMIT_DATA_SUCCESS:
			return Object.keys(action.data).reduce((val, key) => {
				const inputValue = action.data[key]
				val[key] = inputValue
				return val
			}, {})

		case actionTypes.CLEAR_BOOK_FIELDS:
			return {}

		default:
			return state
	}
}

export default combineReducers({
	current: currentDataReducer,
	saved: savedDataReducer,
})

export const getBookInputData = state => state.current
export const getSavedBookInputData = state => state.saved

export const hasUnsavedChanges = state => {
	const current = getBookInputData(state)
	const saved = getSavedBookInputData(state)
	return !_isEqual(current, saved)
}
